import * as React from "react";
import { useState } from "react";
import { Button } from "components/bootstrap";
import { ConfirmDialog } from "components/common";
import { useEnableDetectionChain } from "../../hooks/useDetectionChainsAPI";
const EnableChainAction = ({ chain }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const { mutate: enableChain, isPending: inFlight } = useEnableDetectionChain();
  const total = chain.definitions_count;
  const enabled = chain.enabled_definitions_count;
  const remaining = total - enabled;
  const empty = total === 0;
  const allEnabled = !empty && remaining === 0;
  let label;
  if (inFlight) label = "Enabling\u2026";
  else if (allEnabled) label = "All Enabled";
  else if (enabled > 0) label = `Enable Remaining (${remaining})`;
  else label = "Enable Chain";
  const onConfirm = () => {
    enableChain(chain.name);
    setShowConfirm(false);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      bsSize: "xsmall",
      bsStyle: allEnabled ? "success" : "default",
      onClick: () => setShowConfirm(true),
      disabled: inFlight || empty || allEnabled,
      "data-testid": `enable-chain-${chain.name}`
    },
    label
  ), showConfirm && /* @__PURE__ */ React.createElement(ConfirmDialog, { title: "Enable detection chain", show: true, onConfirm, onCancel: () => setShowConfirm(false) }, `Enable ${remaining} event definition${remaining === 1 ? "" : "s"} in chain "${chain.name}"?`));
};
export default EnableChainAction;
